import get from 'lodash/get';
import types from '../types';
import getErrorMessage from '../utils/getErrorMessage';
import { showToast } from './Toast';

const getCampaignWidgets = payload => {
  return {
    type: types.api.FETCH_NUDGE,
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      queryParams: { campaign: payload.campaign, qid: payload.hotelId, page_type: payload.pageType, clear_cache: true },
      method: 'POST',
      body:
        payload.pageType === 'filter'
          ? {
              hotelId: payload.hotelId,
              required_fields: ['room_type', 'room_number', 'topics_filter', 'city', 'state',"brand"],
              supplyFilterKeys: ['property_id'],
              filters: {
                start_date: '2021-01-01',
                end_date: '2025-01-31'
              }
            }
          : {
              hotelId: payload.hotelId,
              required_fields: ['room_type', 'room_number', 'topics_filter', 'city', 'state'],
              supplyFilterKeys: ['property_id']
            }
    },
    onSuccess: ({ data }) => {
      const response = get(data, 'data', {});
      payload.onSuccess(response);
    },
    onError: ({ error, store }) => {
      store.dispatch(showToast({ message: getErrorMessage(error) }));
      payload.onError();
    }
  };
};

export default getCampaignWidgets;
